import { render, staticRenderFns } from "./SubBtn.vue?vue&type=template&id=0c2f6ec6&scoped=true&"
import script from "./SubBtn.vue?vue&type=script&lang=js&"
export * from "./SubBtn.vue?vue&type=script&lang=js&"
import style0 from "./SubBtn.vue?vue&type=style&index=0&id=0c2f6ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f6ec6",
  null
  
)

export default component.exports